import {checkIfNeutralPlayer} from "../../../utils/players/checkIfNeutralPlayer";

/**
 * Строки модалки захвата: по строке на игрока, который в этом раунде что-то
 * захватил или потерял (сводка редьюсера CAPTURE_CITIES,
 * gameState.lastCityCaptureStats). Захватчики — выше, по очкам за захват.
 *
 * Состояние без сводки (сервер или запись до нее) — строки собираются из
 * самих захватов: города и очки известны, а изменение дохода — нет
 * (incomeKnown: false, доход в строке не показывается).
 *
 * @param {Object[]|undefined} captureStats - gameState.lastCityCaptureStats
 * @param {Object[]} capturedCities - gameState.lastCapturedCities
 * @param {Object[]} players - игроки партии
 * @returns {{player: Object, capturedCount: number, lostCount: number,
 *   winPointsDelta: number, coinsIncomeDelta: number|null,
 *   winPointsIncomeDelta: number|null}[]}
 */
export const buildCityCaptureRows = (captureStats, capturedCities, players) => {
  const findPlayer = (playerId, fallback) => (players || []).find(({id}) => id === playerId) || fallback;

  let rows;
  if (Array.isArray(captureStats) && captureStats.length > 0) {
    rows = captureStats.map((stats) => ({
      player: findPlayer(stats.playerId),
      capturedCount: stats.capturedCount,
      lostCount: stats.lostCount,
      winPointsDelta: stats.winPointsDelta,
      coinsIncomeDelta: stats.coinsIncomeDelta,
      winPointsIncomeDelta: stats.winPointsIncomeDelta,
    }));
  } else {
    const rowsById = new Map();
    const getRow = (player) => {
      if (!rowsById.has(player.id)) {
        rowsById.set(player.id, {
          player: findPlayer(player.id, player),
          capturedCount: 0,
          lostCount: 0,
          winPointsDelta: 0,
          coinsIncomeDelta: null,
          winPointsIncomeDelta: null,
        });
      }
      return rowsById.get(player.id);
    };
    (capturedCities || []).forEach(({fromPlayer, toPlayer, cityWinPoints = 0}) => {
      if (toPlayer && !checkIfNeutralPlayer(toPlayer.id)) {
        const row = getRow(toPlayer);
        row.capturedCount += 1;
        row.winPointsDelta += cityWinPoints;
      }
      if (fromPlayer && !checkIfNeutralPlayer(fromPlayer.id)) {
        const row = getRow(fromPlayer);
        row.lostCount += 1;
        row.winPointsDelta -= cityWinPoints;
      }
    });
    rows = [...rowsById.values()];
  }

  return rows
    .filter((row) => row.player && (row.capturedCount > 0 || row.lostCount > 0))
    .sort((left, right) => (right.winPointsDelta - left.winPointsDelta)
      || (right.capturedCount - left.capturedCount));
};
